document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;

  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".product-scroll-frame-hero").forEach(hero => {
    const img = hero.querySelector(".psfh-product-img");
    const bgTextEl = hero.querySelector(".psfh-bg-text");

    if (!img) return;

    const frameCount = Number(hero.dataset.frameCount) || 0;
    const framePrefix = hero.dataset.framePrefix || "";

    /* =========================================================
       PRELOAD FRAMES (NO FLICKER)
    ========================================================= */

    const frames = [];
    for (let i = 1; i <= frameCount; i++) {
      const image = new Image();
      image.src = `${framePrefix}${String(i).padStart(2, "0")}.png`;
      frames.push(image);
    }

    let currentFrame = 0;

    /* =========================================================
       MAIN PINNED TIMELINE
    ========================================================= */

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: hero,
        start: "top top",
        end: "+=350%",
        scrub: true,
        pin: true,
        anticipatePin: 1
      }
    });

    /* =========================================================
       PHASE 1 — PRODUCT INSERTION
    ========================================================= */

    tl.fromTo(
      img,
      {
        scale: 1.8,
        yPercent: 45,
        rotateX: 8
      },
      {
        scale: 1,
        yPercent: 0,
        rotateX: 0,
        ease: "none",
        duration: 1
      }
    );

    /* =========================================================
       PHASE 2 — FRAME SCRUB (FULLY REVERSIBLE)
    ========================================================= */

    const scrubProxy = { progress: 0 };

    tl.to(scrubProxy, {
      progress: 1,
      duration: 1,
      ease: "none",
      onUpdate: () => {
        const index = Math.min(
          frameCount - 1,
          Math.floor(scrubProxy.progress * frameCount)
        );

        if (index !== currentFrame) {
          currentFrame = index;
          img.src = frames[index].src;

          /* Background text swap (reversible) */
          if (bgTextEl) {
            const textA = bgTextEl.dataset.textA || "";
            const textB = bgTextEl.dataset.textB || "";
            const swapThreshold = 6;

            bgTextEl.textContent =
              index >= frameCount - swapThreshold ? textB : textA;
          }
        }
      }
    });

    /* =========================================================
       HOLD — VISUAL PAUSE (NO MOTION)
    ========================================================= */

    tl.to({}, { duration: 0.3 });

    /* =========================================================
       PHASE 3 HOOK (SAFE, NON-BREAKING)
       Fan / Carousel will attach here later
    ========================================================= */

    ScrollTrigger.create({
      trigger: hero,
      start: "bottom center",
      onEnter: () => {
        if (window.innerWidth >= 769) {
          console.log("Desktop phase reached (fan can start here)");
        } else {
          console.log("Mobile phase reached (carousel can start here)");
        }
      },
      onLeaveBack: () => {
        console.log("Returned to frame animation zone");
      }
    });
  });
});
